/**
 * Fetcher CustomReports
 * @author chensi
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FCustomReports extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/customReports/', '/lpg/admin/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取液化气采购款余额表（海方）（液化气采购款余额表）
    getLPGPurchaseBalance(search) {
        const url = this.spellURL('getLPGPurchaseBalance', 'report/purchaseBalanceSheet');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存液化气采购款余额表（海方）（液化气采购款余额表）
    saveSetAdvancePayment(data) {
        const url = this.spellURL('saveSetAdvancePayment', 'report/setAdvancePayment');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取重瓶/空瓶调拨统计表（重瓶调拨统计表）
    getBottleTransferStatistics(search) {
        const url = this.spellURL(
            'getBottleTransferStatistics',
            'erp/inventory/getBottleTransferStatisticsByDate',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        delete send.date;
        return this.post(url, send);
    }

    // 获取重瓶调拨明细列表（重瓶调拨统计表）
    getBottleTransferDetail(search) {
        const url = this.spellURL(
            'getBottleTransferDetail',
            'erp/inventory/getBottleTransferStatisticsByStore',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取供应商列表（液化气采购款余额表）
    getSupplierList(data) {
        const url = this.spellURL('getSupplierList', 'report/getSupplierList');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取欠瓶报表-门店（欠瓶报表-门店）
    getDebtBottleStatistics(search) {
        const url = this.spellURL('getDebtBottleStatistics', 'report/arrears/storeList');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取欠瓶报表-门店详情（欠瓶报表-门店）
    getDebtBottleStatisticsDetail(search) {
        const url = this.spellURL('getDebtBottleStatisticsDetail', 'report/arrears/customerList');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 导出欠瓶报表-门店详情（欠瓶报表-门店）
    saveExportDebtBottleStatisticsDetail(search) {
        const url = this.spellURL(
            'saveExportDebtBottleStatisticsDetail',
            'report/arrears/exportCustomerArrears',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取发展客户绩效统计列表（发展客户绩效统计）
    getCustomerPerformanceList(search) {
        const url = this.spellURL(
            'getCustomerPerformanceList',
            'Salesman/customerDevelopmentStatistic',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取发展客户绩效统计详情（发展客户绩效统计）
    getCustomerPerformanceDetail(search) {
        const url = this.spellURL(
            'getCustomerPerformanceDetail',
            'Salesman/customerDevelopmentDetail',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 导出发展客户绩效统计详情（发展客户绩效统计）
    saveExportCustomerPerformanceDetail(search) {
        const url = this.spellURL(
            'saveExportCustomerPerformanceDetail',
            'Salesman/exportCustomerDevelopmentDetail',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取气库购销存报表（气库购销存报表）
    getGasInventoryReport(search) {
        const url = this.spellURL('getGasInventoryReport', 'GasStorageReport/detail');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 生成气库购销存报表（气库购销存报表）
    getGenerateGasInventoryReport(search) {
        const url = this.spellURL('getGenerateGasInventoryReport', 'GasStorageReport/generate');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存气库购销存报表（气库购销存报表）
    saveGasInventoryReport(data) {
        const url = this.spellURL('saveGasInventoryReport', 'GasStorageReport/save');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 提交气库购销存报表（气库购销存报表）
    saveSubmitGasInventoryReport(data) {
        const url = this.spellURL('saveSubmitGasInventoryReport', 'GasStorageReport/submit');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取审核购销存报表（审核购销存报表）
    getCheckGasInventoryReport(search, pagination, sorter) {
        const url = this.spellURL('getCheckGasInventoryReport', 'GasStorageReport/list');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 审核通过气库购销存报表（气库购销存报表）
    saveCheckPassGasInventoryReport(data) {
        const url = this.spellURL('saveCheckPassGasInventoryReport', 'GasStorageReport/approve');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 审核不通过气库购销存报表（气库购销存报表）
    saveCheckNotPassGasInventoryReport(data) {
        const url = this.spellURL('saveCheckNotPassGasInventoryReport', 'GasStorageReport/reject');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取欠款统计表（欠款统计表）
    getDebtStatistics(search) {
        const url = this.spellURL('getDebtStatistics', 'report/arrears/storeArrearsStatistics');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取客户欠款明细（客户欠款明细）
    getDebtDetail(search) {
        const url = this.spellURL('getDebtDetail', 'report/arrears/customerArrearsDetail');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }
}

export const $fetchCustomReports = new FCustomReports();
